<template>
  <main>
    <div class="Gameproblem">
      <Tou></Tou>
      <div class="GP_all">
        <div class="title gpconente">
          <!-- <div>您在哪一款产品中遭遇到困难?</div> -->
        </div>
        <ul class="routing">
          <li>
            <span @click="Instructions_ER" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions current">客户端问题</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="gpconente niceall">
          <li @click="linkdenglu">
            <!-- <router-link :to="{ path: `/` }"> -->
            <div class="gpclink">
              <div class="lefttou"></div>
              文件丢失
              <div class="triangles"></div>
            </div>
            <!-- </router-link> -->
          </li>
          <li>
            <a
              href="https://www.haixingcloud.com/#/DownLoad"
              class="gpclink"
              style="color: #fff; display: block"
            >
              <div class="lefttou"></div>
              下载
              <div class="triangles"></div>
            </a>
          </li>
          <li>
            <router-link :to="{ path: `/Pro_Client` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                安装问题
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/Pro_SetIn` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                登录问题
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/Pro_String` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                设置
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/Pro_Experience` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                游戏体验
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>
<script>
import Tou from "@/components/Tou.vue"
export default {
  components:{Tou},
  data(){
    return{

    }
  },
  mounted(){

  },
  computed:{
  },
  methods:{
    height_game(){
      // this.$refs.game      
    },
    linkdenglu () {
      // this.$emit('global:denglu')
      console.log(this.$store.state.count)
      if(this.$store.state.count == '' || this.$store.state.client == 0){
        this.$message.error('您暂未登录，请先登录/注册！')
        const that = this
        this.$store.commit('addNice',1)
        setTimeout(function(){
          that.$emit('global:denglu')
        },1000)
      }else if(this.$store.state.count != ''){
        this.$message({
          message: '跳转页面中，请稍后',
          type: 'success'
        })
        const nice = this
        setTimeout(function(){
          nice.$router.push('./Pro_download')
        },1000)
      }
    },
    Instructions_ER(){
      this.$router.push('./faq')
    }
  },
}
</script>


<style lang="scss" scoped>
html,
body {
  height: 100%;
  width: 100%;
}
.GP_all {
  margin-top: 160px;
  padding-bottom: 35px;
}
.Gameproblem {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #100e2e;
  box-sizing: border-box;
  overflow: hidden;
}
.title {
  font-size: 18.3px;
  color: #5eafde;
  background-color: transparent !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.gpconente {
  width: 1070px;
  margin: 0 auto;
  // border: 1px solid red;
  background-color: #0d0b26;
  margin-top: 15px;
  padding-top: 30px;
  overflow: hidden;
  padding-bottom: 40px;
}
.gpconente li {
  width: 712px;
  margin: 15px auto;
  height: 44px;
  text-indent: 25px;
  cursor: pointer;
  background-color: #445468;
  font-size: 16px;
  line-height: 44px;
  user-select: none;
  transition-duration: 0.3s;
}
.gpconente li:hover {
  background: rgba(68, 84, 104, 0.6);
  color: white;
}
.gpclink {
  color: white !important;
}
.gpclink:hover {
}
.lefttou {
  height: 44px;
  width: 3px;
  float: left;
  background-color: transparent;
}
.gpconente li:hover .lefttou {
  background-color: #f4c91d;
}
.triangles {
  float: right;
  margin-right: 15px;
  width: 0;
  height: 0;
  border-width: 8px 0px 8px 16px;
  border-style: solid;
  border-color: transparent transparent transparent #a0b3cb;
  margin-top: 14px;
}
@media screen and (min-width: 350px) and (max-width: 1000px) {
  .GP_all {
    margin-top: 0;
  }
  .niceall {
    width: 100%;
    // height: 520px;
    // overflow-y: auto;
  }
  .gpconente li {
    width: 80%;
    font-size: 14px;
  }
}
@media screen and (max-width: 349px) {
  .GP_all {
    margin-top: 0;
  }
  .niceall {
    width: 100%;
    height: 450px;
    overflow-y: auto;
    padding-bottom: 80px;
  }
  .gpconente li {
    width: 80%;
    font-size: 14px;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
    margin-top: 45px;
  }
}

.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .GP_all {
    margin-top: 180px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .GP_all {
    margin-top: 120px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CommonProblem/Client.vue